import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

//component root
import { CreditCardComponent } from "./credit-card.component";
//routes
import { CreditCardRoutes as routes } from "./credit-card.routes";

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports:[
      CreditCardComponent
  ],
  declarations: [CreditCardComponent]
})
export class CreditCardModule { }
